module.exports = __webpack_public_path__ + "img/vegetable-arugula-190x100.e5e15647.jpg";